import { publicApi } from "../../api";

export interface DocumentVerificationResponse {
  valido: boolean;
  mensagem: string;
  codigoVerificacao?: string;
  tipoDocumento?: string;
  tipoDocumentoDescricao?: string;
  dataGeracao?: string;
  candidatoNome?: string;
  processoIdentificador?: string;
  unidadeNome?: string;
  totalVerificacoes?: number;
}

export class VerificacaoDocumentoViewModel {
  static async verificarDocumento(codigo: string): Promise<DocumentVerificationResponse> {
    try {
      const response = await publicApi.get<DocumentVerificationResponse>(
        `/public/verificacao/${codigo}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
